import { Currency } from "@daytrip/legacy-enums";
import { Expose } from "class-transformer";
import { IsDefined, IsEnum, IsNumber, Max, Min } from "class-validator";

import { GObjectType } from "../graphql";
import { CDBaseEntity, CDColumn, CDEntity } from "../orm";

@CDEntity("orderCommission")
@GObjectType("OrderCommission")
export class OrderCommission extends CDBaseEntity {
    @CDColumn()
    @IsDefined()
    @IsNumber()
    @Min(0)
    @Max(100)
    @Expose()
    public percentage: number;

    @CDColumn()
    @IsDefined()
    @IsNumber()
    @Expose()
    public valueInPricingCurrency: number;

    @CDColumn()
    @IsDefined()
    @IsEnum(Currency)
    @Expose()
    public commissionCurrency: Currency;

    @CDColumn()
    @IsDefined()
    @IsNumber()
    @Expose()
    public commissionCurrencyExchangeRate: number;

    @CDColumn()
    @IsDefined()
    @IsNumber()
    @Expose()
    public valueInCommissionCurrency: number;
}
